import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "i18n/i18n";
import fleetlogicAPI from "helpers/fleetlogicAPI";
import isEmpty from "lodash/isEmpty";
import { useNavigate } from "react-router-dom";
import { Icons, Button } from "@texada/ui";
import {
  USER_INSTANCE_URL,
  NON_UPGRADED_USER_URL,
} from "constants/AppConstants";
import "./Quickbar.scss";

const UserInstance: React.FC = props => {
  const navigate = useNavigate();
  const user = useSelector(state => state.auth.user);
  const [userinstance, setUserInstance] = useState({});

  useEffect(() => {
    if (user.upgraded) {
      getUpgradedInstances();
      return;
    }
    getInstances();
  }, []);

  async function getUpgradedInstances() {
    try {
      const res = await fleetlogicAPI.get(USER_INSTANCE_URL);
      setUserInstance({
        companies: res.data.userinstancecompany_set.map(e => ({
          ...e,
          company_id: e.company.id,
          tenant_id: e.company.tenant_id,
        }))
      });
    } catch (err) {
      console.log(err);
    }
  }

  async function getInstances() {
    try {
      const res = await fleetlogicAPI.get(
        `${NON_UPGRADED_USER_URL}/${user.id}/instances`
      );
      setUserInstance({
        companies: res.data.map(e => ({ ...e, nick_name: e.title }))
      });
    } catch (err) {
      console.log(err);
    }
  }

  async function onSwitchInstance() {
    props.setIsLoading(true);
    if (props.duration !== null) {
      await props.clockOut();
    }
    localStorage.removeItem("verified");
    localStorage.removeItem("jwtToken");
    props.setIsLoading(false);
    navigate(`/?email=${user.email}&switchInstance=true`);
  }

  if (isEmpty(userinstance) || userinstance?.companies?.length <= 1) {
    return null;
  }

  return (
    <Button
      className="quickbar-button"
      icon={{ type: "left", render: Icons.SwapHoriz }}
      onClick={onSwitchInstance}
    >
      {i18n.t("switch_company")}
    </Button>
  );
};

export default UserInstance;
